import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { MdContentCopy } from 'react-icons/md';
import Button from '../../components/Button';
import SimpleFooter from '../../components/SimpleFooter';
import SimpleHeader from '../../components/SimpleHeader';
import styles from './login.module.scss';
import './login.scss';

export default function TwoFactorSecretKey(props) {
    const history = useHistory();
    const location = useLocation();
    const [copied, setCopied] = React.useState(false);

    // Get data from location state
    const secret = location.state?.secret;
    const uri = location.state?.uri;
    const sessionData = location.state?.sessionData;
    const username = location.state?.username;
    const password = location.state?.password;

    const handleContinue = () => {
        // Navigate to OTP verification page with credentials and session data
        history.push({
            pathname: '/verify-2fa',
            state: {
                sessionData,
                username,
                password
            }
        });
    };

    const handleUseQRCode = () => {
        // Go back to QR code page
        history.push({
            pathname: '/setup-2fa',
            state: {
                uri,
                secret,
                sessionData,
                username,
                password
            }
        });
    };

    const handleCopySecret = () => {
        if (secret) {
            navigator.clipboard.writeText(secret).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        }
    };

    return (
        <div className='h-100 login-page'>
            <SimpleHeader />
            <Container>
                <ContentBox>
                    <Title>Secret key</Title>
                    <Description>
                        If you have trouble scanning the QR code, open your <strong>authenticator app</strong> and chose the manual entry option. Enter the secret key to add the CAC account.
                    </Description>

                    <SecretKeyContainer>
                        <SecretKeyLabel>Secret key</SecretKeyLabel>
                        <SecretKeyBox>
                            <SecretKeyText>{secret || 'Loading...'}</SecretKeyText>
                            <CopyButton onClick={handleCopySecret} title="Copy to clipboard">
                                <MdContentCopy size={20} />
                            </CopyButton>
                        </SecretKeyBox>
                        {copied && (
                            <p style={{ fontSize: '12px', color: '#28a745', marginTop: '5px' }}>
                                Copied!
                            </p>
                        )}
                    </SecretKeyContainer>

                    <QRCodeLink onClick={handleUseQRCode}>
                        Use the QR Code instead
                    </QRCodeLink>

                    <Button
                        text='CONTINUE'
                        className={styles.loginBtn}
                        onClick={handleContinue}
                    />
                </ContentBox>
            </Container>
            <SimpleFooter {...props} />
        </div>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: #f5f5f5;
    height: 83vh;

    @media (max-width: 768px) {
        padding: 20px 15px;
    }
`;

const ContentBox = styled.div`
    padding: 40px 20px;
    max-width: 500px;
    width: 100%;
    text-align: center;

    @media (max-width: 768px) {
        padding: 20px 15px;
    }
`;

const Title = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

const Description = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
    line-height: 1.6;

    @media (max-width: 768px) {
        font-size: 13px;
        margin-bottom: 20px;
    }
`;

const SecretKeyContainer = styled.div`
    margin: 30px 0;
`;

const SecretKeyLabel = styled.p`
    font-size: 13px;
    color: #666;
    margin-bottom: 10px;
    font-weight: 600;
`;

const SecretKeyBox = styled.div`
    position: relative;
    margin: 20px 0;
    padding: 20px 50px 20px 20px;
    background-color: rgba(255, 255, 255, 0.5);
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        padding: 15px 45px 15px 15px;
    }

    @media (max-width: 480px) {
        padding: 12px 40px 12px 12px;
    }
`;

const SecretKeyText = styled.p`
    font-family: monospace;
    font-size: 16px;
    color: #333;
    word-break: break-all;
    margin: 0;
    letter-spacing: 2px;

    @media (max-width: 768px) {
        font-size: 14px;
        letter-spacing: 1px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        letter-spacing: 0.5px;
    }
`;

const CopyButton = styled.button`
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;

    &:hover {
        color: #28a745;
    }

    &:active {
        transform: translateY(-50%) scale(0.95);
    }
`;

const QRCodeLink = styled.span`
    font-size: 14px;
    color: #28a745;
    cursor: pointer;
    font-weight: 500;
    margin: 20px 0;
    display: inline-block;
    
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: 768px) {
        font-size: 13px;
    }
`;